import React from 'react'
import styled from 'styled-components'
import { Box } from '@usap/uicomponents'
import { PaypalMessage } from '@usap/widgets'
import useWmoEnabled from '../../../../../hooks/useWmoEnabled'

const PaypalMessageWrapper = styled(Box)`
  margin-top: 8px;
  width: 100%;
  height: 40px;
  line-height: 20px;
  color: #333333;
  letter-spacing: .25px;
  margin-bottom: 10px;

  @media (min-width: 480px) and (max-width: 1008px) {
    height: 22px;
  }
`

const PaypalMessageWrapperWmo = styled(Box)`
  margin-top: 8px;
  width: 100%;
  height: 50px;
  line-height: 20px;
  color: #333333;
  letter-spacing: .25px;
  background: #F4F4F4;
  border-radius: 4px;
  padding: 8px;

  @media (min-width: 480px) and (max-width: 1008px) {
    height: 22px;
  }
`

const ZipPayment = props => {
  const { totalAfterTax } = props
  const isWmoEnabled = useWmoEnabled()

  if (isWmoEnabled) {
    return (
      <PaypalMessageWrapperWmo>
        <PaypalMessage
          amount={totalAfterTax}
          textSize="12"
        />
      </PaypalMessageWrapperWmo>
    )
  }

  return (
    <PaypalMessageWrapper>
      <PaypalMessage
        amount={totalAfterTax}
        textSize="14"
      />
    </PaypalMessageWrapper>
  )
}

export default ZipPayment
